// store/index.js
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import { API_URL } from '@/config';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    // token สำหรับเรียก API (ได้จาก /loginAzure) หมดอายุตามที่ backend กำหนด
    token: localStorage.getItem('token') || null,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      localStorage.setItem('user', JSON.stringify(user));
    },
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem('token', token);
      } else {
        localStorage.removeItem('token');
      }
    },
    LOGOUT(state) {
      state.user = null;
      // state.token = '';
      localStorage.removeItem('user');
    },
  },
  actions: {
    async login({ commit }, { username }) {      
      try {
        const response = await axios.post(`${API_URL}/login`, { username });                
        const { user } = response.data;

        localStorage.setItem('user', JSON.stringify(user));
        commit('SET_USER', user);
        
        console.log(user);
        

      } catch (error) {
        console.error('Login failed:', error);
      }
    },
    logout({ commit }) {
      localStorage.removeItem('user');
      commit('SET_USER', null);
      commit('SET_TOKEN', null);
    },
    setUser({ commit }, user) {
      commit('SET_USER', user);
    },
    setSession({ commit }, { user, token }) {
      commit('SET_USER', user);
      commit('SET_TOKEN', token);
    },
  },
  getters: {
    getUser: state => state.user,
    // login อยู่ = มีทั้งข้อมูลผู้ใช้และ token (session เก่าก่อนมี token ต้อง login ใหม่)
    isLoggedIn: state => !!(state.user && state.token),
  },
});
